import Tag from 'src/models/Tag';

export default class {
    index: number;
    state: boolean;
    tag: Tag;
}


// WEBPACK FOOTER //
// ./src/models/SearchListData.tsx